import React from 'react';
import { lancamentosMock } from './mock';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Stack, Typography } from '@mui/material';

export default function Financeiro() {
  const total = lancamentosMock.reduce((acc, l) => acc + (Number(l.valor) || 0), 0);
  return (
    <Stack spacing={2}>
      <Typography variant="h6">Movimentações</Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Data</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell align="right">Valor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lancamentosMock.map((l) => (
              <TableRow key={l.id} hover>
                <TableCell>{l.data}</TableCell>
                <TableCell>{l.descricao}</TableCell>
                <TableCell>
                  <Chip size="small" label={l.tipo} color={l.tipo === 'Credito' ? 'success' : 'error'} />
                </TableCell>
                <TableCell align="right">{l.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={3} align="right"><strong>Total</strong></TableCell>
              <TableCell align="right"><strong>{total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}
